import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';

import { AdminHtmlLayoutComponent } from './layouts/admin/admin-html/admin-html-layout.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { AuthGuard } from './shared/auth/auth-guard.service';

import { Full_ADMIN_ROUTES, Full_ROUTES } from './shared/routes/full-layout.routes';
import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';
import { LoginPageComponent } from './pages/login/login-page.component';
import { MainHtmlLayoutComponent } from './layouts/site/main-page/main-html-layout.component';

const routerOptions: ExtraOptions = {
  onSameUrlNavigation: 'reload',
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
};

/**
 * Pay attention!! The order matters!
 */
const appRoutes: Routes = [
  { path: 'manage/login', component: LoginPageComponent, data: { title: 'Login' } },
  {
    path: 'manage',
    redirectTo: 'manage/home/dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: '/gvp',
    pathMatch: 'full',
  },
  { path: 'manage', component: ContentLayoutComponent, data: { title: 'content Views' }, children: CONTENT_ROUTES, canActivate: [AuthGuard], canActivateChild: [AuthGuard]},
  { path: 'manage', component: AdminHtmlLayoutComponent, data: { title: 'content Views' }, children: Full_ADMIN_ROUTES, canActivate: [AuthGuard], canActivateChild: [AuthGuard]},
  { path: '', component: MainHtmlLayoutComponent, data: { title: 'full Views' }, children: Full_ROUTES },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, routerOptions)
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
